import { Reviews, ReviewsGroupProps } from '@gositeinc/ui'

export const ReviewsGroup = ({ data }: ReviewsGroupProps): JSX.Element => {
  return (
    <Reviews data={data} />
  )
}
